import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { OverlayTrigger, Form, Modal, Button, Breadcrumb } from "react-bootstrap";
import UtilsService from "../../../core/service/UtilsService";
import "./SupplierCreate.scss";
import SupplierService from "../../../core/service/SupplierService";
import PhoneNumber from "../../../components/PhoneNumber/PhoneNumber";
import { useNavigate, useLocation } from "react-router-dom";
import InvitationService from "../../../core/service/InvitationService";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import Utils from "../../../core/utilities/Utils";
import SupplierTypeModal from "../SupplierTypeModal/SupplierTypeModal";
import { Typeahead } from "react-bootstrap-typeahead";

function SupplierCreate({ t }) {
  const location = useLocation();
  const data = location.state;
  //console.log("data",data);
  const navigate = useNavigate();
  const [pageStatus, setPageStatus] = useState(data ? "Edit" : "Create");
  const [supplierName, setSupplierName] = useState(data ? data.legalName : "");
  const [invitationId, setInvitationId] = useState(data ? data.id : "");
  const [email, setEmail] = useState(data ? data.email : "");
  const [contact, setContact] = useState(data ? data.contactNumber.number : "");
  const [phoneCodeCountry, setPhoneCodeCountry] = useState(
    data ? data.contactNumber.code.name : ""
  );
  const [defaultContactCode, setDefaultContactCode] = useState(
    data ? data.contactNumber.code.id : ""
  );
  const [defaultContactId, setDefaultContactId] = useState(
    data ? data.contactNumber.id : ""
  );
  const [phoneCode, setPhoneCode] = useState([]);
  const [contactCode, setContactCode] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [supplierTypesArr, setSupplierTypesArr] = useState([]);
  const [supplierTypeVal, setSupplierTypeVal] = useState(
    data ? data.supplierType : ""
  );
  const [supplierType, setSupplierType] = useState(
    data ? data.supplierType.id : ""
  );
  const [contactPerson, setContactPerson] = useState(data ? data.name : "");
  const [sendInvite, setSendInvite] = useState(false);
  const [show, setShow] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [showCreateSupplier, setShowCreateSupplier] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isAddNew, setIsAddNew] = useState(false);
  //  console.log("glbButtonDisable",glbButtonDisable);
  useEffect(() => {
    getSupplierType();
    getPhoneCodes();
  }, []);


  const getSupplierType = async (e) => {
    var data = JSON.parse(localStorage.getItem("authority"));
    const companyid = data.profile.company.id;
    if (companyid) {
      setCompanyId(companyid);
      SupplierService.getSupplierTypes(companyid)
        .then((responseCompany) => {
          const types = responseCompany.data;
          types?.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          setSupplierTypesArr([...types]);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
        });
    }
  };

  const getPhoneCodeVal = (data) => {
    if (data.length > 0) {
      setContactCode(data[0].id);
    }
  };
  const getPhoneNumberVal = (data) => {
    setContact(data);
  };
  const getPhoneCodes = () => {
    UtilsService.getPhoneCodes()
      .then((response) => {
        setPhoneCode([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };
  const handleClose = () => setShow(false);
  const handleSupplierClose = () => setShowCreateSupplier(false);

  const handleCreate = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      setShowCreateSupplier(true);
    }
    setValidated(true);
  };
  // const handleEmailExist = (e) => {
  //   var email = e.target.value;
  //   if (email) {
  //     let regEmail =
  //       /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //     if (regEmail.test(email)) {
  //       SupplierService.checkCompanyEmailExist(email)
  //         .then((responseEmail) => {
  //           if (responseEmail.data.length > 0) {
  //             var data = responseEmail.data;
  //             //console.log(data);
  //             !contactPerson && setContactPerson(data[0].contactName);
  //             !contactCode && setContactCode(data[0].phoneNumber.code.id);
  //             !contact && setContact(data[0].phoneNumber.number);
  //           }
  //         })
  //         .catch((error) => {
  //           console.log("err", error);
  //         });
  //     }
  //   }
  // };
  const handleConfirm = (e) => {
    setShowCreateSupplier(false);
    if (pageStatus === "Edit") {
      const params = {
        id: invitationId,
        legalName: supplierName,
        name: contactPerson,
        email: email,
        contactNumber: {
          // id: item.phoneNumber.code.id,
          code: {
            id: contactCode,
          },
          number: contact,
        },
        sendInvite: sendInvite,
        supplierType: null,
      };
      updateCompany(params, invitationId);
    } else {
      var supplierDetails = {
        name: contactPerson,
        legalName: supplierName,
        email: email,
        contactNumber: {
          code: {
            id: contactCode,
          },
          number: contact,
        },
        sendInvite: sendInvite,
        supplierType: {
          id: supplierType,
        },
      };
      SupplierService.createSupplier(supplierDetails)
        .then((response) => {
          if (response.status === 201) {
            // setResponseMsg(t("NewSupplierCreated.label"));
            // setShow(true);
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            navigate("/company_admin/list_supplier");
          }
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
          var errorRes = error.response;
          if (errorRes.status === 400) {
            setResponseMsg(errorRes.data.message);
            setShow(true);
          }
          // else {
          //   toast.error(error.message, {
          //     position: toast.POSITION.TOP_RIGHT,
          //   });
          // }
          // setShow(true);
        });
    }
  };
  const updateCompany = (params, invitationId) => {
    InvitationService.updateCompanyInvitation(params, invitationId)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/company_admin/list_supplier");
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        // var errorRes = error.response;
        // toast.error(error.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };
  const handleAddType = () => {
    setIsAddNew(true);
  };
  const callbackTypeModal = () => {
    setIsAddNew(false);
    getSupplierType();
  };
  var title;
  pageStatus === "Edit"
    ? (title = t("EditSupplier.label"))
    : (title = t("CreateSupplier.label"));
  return (
    <>
      <section>
        <div className="Main_body">
          <div className="Company_formBox col-lg-6">
            <div className="List_header">
              <Breadcrumb className="h5">
                <Breadcrumb.Item onClick={() => {
                  navigate(`/company_admin/list_supplier`);
                }} > {t("Suppliers.label")}</Breadcrumb.Item>
                <Breadcrumb.Item active> {title}</Breadcrumb.Item>
              </Breadcrumb>
            </div>

            <Form noValidate validated={validated} onSubmit={handleCreate}>
              {/* <form onSubmit={handleCreate}> */}
              <div className="row">
                <div className="col-lg-12 py-2">
                  <label  className="mb-1">
                    {t("SupplierName.label")} *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={supplierName}
                    onChange={(e) => setSupplierName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-lg-12 py-2">
                  <label  className="mb-1">{t("Emailid.label")} *</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="col-lg-12 py-2">
                  <label  className="mb-1">
                    {t("ContactPerson.label")} *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={contactPerson}
                    onChange={(e) => setContactPerson(e.target.value)}
                    required
                  />
                </div>
                <div className="col-lg-12 py-2">
                  <label className="mb-1">
                    {t("ContactNumber.label")} *
                  </label>
                  <div className="row px-1">
                    <PhoneNumber
                      onCodeSelected={getPhoneCodeVal}
                      phoneNumber={getPhoneNumberVal}
                      codelabel={t("phoneCode.label")}
                      phoneCode={contactCode}
                      contact={contact}
                      defaultContactCode={defaultContactCode}
                      phoneCodeCountry={phoneCodeCountry}
                      defaultContactId={defaultContactId}
                    />
                  </div>
                </div>
                <div className="col-lg-12 py-2">
                  <label  className="mb-1">
                    {t("SupplierType.label")} *
                  </label>
                  <div className="row">
                    <div className="col-lg-9">
                      <Typeahead
                        clearButton
                        defaultSelected={pageStatus === 'Edit' ? [supplierTypeVal] : []}
                        id="supplierTypeSelector"
                        labelKey={(options) => options.name}
                        onChange={(selected) => {
                          if (selected[0]) {
                            setSupplierType(selected[0].id);
                          }
                        }}
                        options={supplierTypesArr}
                        placeholder={t("Select.label")}/>
                    </div>
                    <div className="col-lg-3 ">
                      <OverlayTrigger
                        placement="top"
                        overlay={Utils.renderTooltip(
                          t("AddNewSupplierType.label")
                        )}
                      >
                        <Link to="/company_admin/create_supplier">
                          <Button
                            variant="primary"
                            onClick={handleAddType}
                          >
                            {t("AddNew.label")}
                          </Button>
                        </Link>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 py-2">
                  <div className="pb-2 form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="exampleCheck1"
                      defaultChecked={sendInvite}
                      onChange={() => setSendInvite(!sendInvite)}
                    />
                    <label className="form-check-label" htmlFor="exampleCheck1">
                      {t("SupplierSendInvitation.label")}
                    </label>
                  </div>
                </div>
                <div className="col-lg-12 py-2 text-center">
                  <button
                    type="submit"
                    className="btn btn-secondary me-2 px-4"
                    onClick={() => { navigate(`/company_admin/list_supplier`); }}
                  >
                    {t("Cancel.label")}
                  </button>
                  {data ? (
                    <button type="submit" className="btn  btn-primary px-4">
                      {t("Update.label")}
                    </button>
                  ) : (
                    <button type="submit" className="btn  btn-primary px-4">
                      {t("Create.label")}
                    </button>
                  )}
                </div>
              </div>

              {/* </form> */}
            </Form>
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                < Modal.Title as="h5"></Modal.Title>
              </Modal.Header>
              <Modal.Body>{responseMsg}</Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                  {t("Ok.label")}
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={showCreateSupplier} onHide={handleSupplierClose}
              aria-labelledby="contained-modal-title-vcenter"
              centered>
              <Modal.Header closeButton>
                < Modal.Title as="h5">{t("CreateSupplier.label")}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {pageStatus === "Create"
                  ? t("NewCompanyNamed.label") + "  " + supplierName + " " + t("WillbeCreated.label") + "  "
                  : supplierName + " " + t("WillbeUpdated.label") + "  "}  {sendInvite &&
                    t("and.label") + " " + t("InvitationSend.label") + " " + email}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={handleSupplierClose}
                  autoFocus
                >
                  {t("Discard.label")}
                </Button>
                <Button variant="primary" onClick={handleConfirm} className="sbmBtn">
                  {t("Confirm.label")}
                </Button>
              </Modal.Footer>
            </Modal>
            {isAddNew && (
              <SupplierTypeModal
                isModal={isAddNew}
                callbackModal={callbackTypeModal}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default withTranslation()(SupplierCreate);
